import { nanoid } from 'nanoid';
import type { Slug, Vibe } from '../types';

export function parseSlugs(
  raw: string,
  batchId: string,
  universeId: string,
  vibe?: Vibe,
  guidance?: string
): Slug[] {
  const now = Date.now();
  const slugs: Slug[] = [];
  const trimmedGuidance = guidance?.trim() || undefined;
  const re = /<slug>\s*<title>([\s\S]*?)<\/title>\s*<hook>([\s\S]*?)<\/hook>\s*<\/slug>/g;
  let m: RegExpExecArray | null;
  while ((m = re.exec(raw)) !== null) {
    const title = m[1].trim();
    const hook = m[2].trim();
    if (!title || !hook) continue;
    slugs.push({
      id: nanoid(10),
      universeId,
      title,
      hook,
      createdAt: now,
      batchId,
      vibe,
      guidance: trimmedGuidance,
    });
  }
  // Fallback: if no XML matched, try numbered lines (e.g. "1. Title — hook")
  if (slugs.length === 0) {
    const lines = raw.split(/\n/).map((l) => l.trim()).filter(Boolean);
    for (const line of lines) {
      const numbered = line.match(/^\d+[.)]\s*(.+?)[:—-]\s*(.+)$/);
      if (numbered) {
        slugs.push({
          id: nanoid(10),
          universeId,
          title: numbered[1].trim(),
          hook: numbered[2].trim(),
          createdAt: now,
          batchId,
          vibe,
          guidance: trimmedGuidance,
        });
      }
    }
  }
  return slugs;
}

export function parseOutlineBeats(raw: string): { heading: string; body: string }[] {
  const beats: { heading: string; body: string }[] = [];
  // Match "## Heading\n...body..." or "1. Heading\n...body..." chunks.
  const headRe = /^(?:#{1,3}\s+|[-*]\s+|\d+[.)]\s+)(.+)$/gm;
  const matches: { heading: string; start: number; end: number }[] = [];
  let m: RegExpExecArray | null;
  while ((m = headRe.exec(raw)) !== null) {
    matches.push({ heading: m[1].trim(), start: m.index, end: m.index + m[0].length });
  }
  for (let i = 0; i < matches.length; i++) {
    const body = raw
      .slice(matches[i].end, i + 1 < matches.length ? matches[i + 1].start : undefined)
      .trim();
    beats.push({ heading: matches[i].heading, body });
  }
  return beats;
}
